export default () => {
    const hideCookieBot = () => {
        const cookiebotWidget = document.getElementById('CookiebotWidget');

        if (cookiebotWidget) {
            cookiebotWidget.style.display = 'none';
        }
    };

    const showCookieBot = () => {
        const cookiebotWidget = document.getElementById('CookiebotWidget');

        if (cookiebotWidget) {
            cookiebotWidget.style.display = 'block';
        }
    };

    return {
        hideCookieBot,
        showCookieBot,
    };
};
